import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-editar-pregunta',
  templateUrl: './editar-pregunta.component.html',
  styleUrls: ['./editar-pregunta.component.css']
})
export class EditarPreguntaComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
